import chipPlaceUrl from '../assets/audio/chip-place.mp3?url'
import slideStripUrl from '../assets/audio/slide-strip.mp3?url'
import tile0xUrl from '../assets/audio/tile-0x.mp3?url'
import tile2xUrl from '../assets/audio/tile-2x.mp3?url'
import tile5xUrl from '../assets/audio/tile-5x.mp3?url'
import tile10xUrl from '../assets/audio/tile-10x.mp3?url'
import tile100xUrl from '../assets/audio/tile-100x.mp3?url'
import tile1000xUrl from '../assets/audio/tile-1000x.mp3?url'

const SOUND_ASSETS = {
	chipPlace: chipPlaceUrl,
	slideStrip: slideStripUrl,
	tile0x: tile0xUrl,
	tile2x: tile2xUrl,
	tile5x: tile5xUrl,
	tile10x: tile10xUrl,
	tile100x: tile100xUrl,
	tile1000x: tile1000xUrl,
} as const

const TIER_SOUND = {
	dark: 'tile0x',
	white: 'tile2x',
	blue: 'tile5x',
	orange: 'tile10x',
	green: 'tile100x',
	diamond: 'tile1000x',
} as const

export class SoundManager {
	private static _instance: SoundManager | null = null
	private readonly audioPool = new Map<keyof typeof SOUND_ASSETS, HTMLAudioElement>()
	private volume = 0.8
	private isMuted = false
	private loaded = false

	static get instance() {
		if (!this._instance) {
			this._instance = new SoundManager()
		}

		return this._instance
	}

	async load() {
		if (this.loaded) {
			return
		}

		;(Object.keys(SOUND_ASSETS) as Array<keyof typeof SOUND_ASSETS>).forEach((key) => {
			const audio = new Audio(SOUND_ASSETS[key])
			audio.preload = 'auto'
			audio.volume = this.volume
			this.audioPool.set(key, audio)
		})

		this.loaded = true
	}

	setVolume(volume: number) {
		this.volume = Math.max(0, Math.min(1, volume))
		this.audioPool.forEach((audio) => {
			audio.volume = this.volume
		})
	}

	play(key: keyof typeof SOUND_ASSETS) {
		if (this.isMuted || this.volume <= 0) {
			return
		}

		if (!this.loaded) {
			void this.load()
		}

		const audio = this.audioPool.get(key)
		if (!audio) {
			return
		}

		try {
			const clone = audio.cloneNode(true) as HTMLAudioElement
			clone.volume = this.volume
			clone.currentTime = 0
			void clone.play().catch(() => undefined)
		} catch {
			// Ignore autoplay failures.
		}
	}

	playTileSound(tier: keyof typeof TIER_SOUND) {
		this.play(TIER_SOUND[tier])
	}

	stopAllGameplay() {
		this.audioPool.forEach((audio) => {
			audio.pause()
			audio.currentTime = 0
		})
	}

	mute() {
		this.isMuted = true
		this.stopAllGameplay()
	}

	unmute() {
		this.isMuted = false
	}
}
